export default "__VITE_ASSET__MnJvHTqm__"